var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login",attrs:{"id":"main-content"}},[_c('header-vue'),_c('main-vue'),_c('footer-vue')],1)}
var staticRenderFns = []

export { render, staticRenderFns }